import './marca.css'

const base = process.env.PUBLIC_URL || ''

// Animação em imagem (como um GIF, com fundo transparente): roda sozinha, mesmo com o
// navegador ocupado montando a tela, o que uma animação feita por CSS não garante.
// Uma imagem para cada tema; o CSS mostra a certa.
// className vem do Spin do antd quando esta marca é o indicador padrão (index.js)
function MarcaYrm({ className = '', pequena = false }) {
  return (
    <span className={`yrm-marca ${pequena ? 'yrm-marca--pequena' : ''} ${className}`.trim()} aria-hidden='true'>
      <img className='claro' src={`${base}/yrm-carregando-claro.png`} alt='' />
      <img className='escuro' src={`${base}/yrm-carregando-escuro.png`} alt='' />
    </span>
  )
}

export default MarcaYrm
